import FuseNavigation from '@fuse/core/FuseNavigation';
import clsx from 'clsx';
import { useMemo } from 'react';
import { useAppDispatch } from '@/store/hooks';
import useThemeMediaQuery from '@fuse/hooks/useThemeMediaQuery';
import { FuseNavigationProps } from '@fuse/core/FuseNavigation/FuseNavigation';
import { navbarCloseMobile } from '../navbar/navbarSlice';
import useNavigation from './hooks/useNavigation';

/**
 * Navigation
 */

type NavigationProps = Partial<FuseNavigationProps>;

function Navigation(props: NavigationProps) {
  const { className = '', layout = 'vertical', dense, active } = props;
  const { navigation } = useNavigation();

  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));

  const dispatch = useAppDispatch();

  return useMemo(() => {
    function handleItemClick() {
      if (isMobile) {
        dispatch(navbarCloseMobile());
      }
    }

    return (
      <FuseNavigation
        className={clsx('navigation flex-1', className)}
        navigation={navigation}
        layout={layout}
        dense={dense}
        active={active}
        onItemClick={handleItemClick}
        checkPermission
      />
    );
  }, [dispatch, isMobile, navigation, active, className, dense, layout]);
}

export default Navigation;
